function easeInOutCubic(t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t*t + b
  return c/2*((t-=2)*t*t + 2) + b
}

module.exports = function (el) {
  var el = document.querySelector(el)
  var rect = el.getBoundingClientRect()
  var root = /firefox|trident/i.test(navigator.userAgent) ? document.documentElement : (document.scrollingElement ? document.scrollingElement: document.body) 
  var startTime
  var startPos = root.scrollTop
  var endPos = rect.top
  var maxScroll = root.scrollHeight - window.innerHeight
  var scrollEndValue = startPos + endPos < maxScroll ? endPos : maxScroll - startPos
  var duration = 900
  var scroll = function(timestamp) {
    startTime = startTime || timestamp
    var elapsed = timestamp - startTime
    var progress = easeInOutCubic(elapsed, startPos, scrollEndValue, duration)
    root.scrollTop = progress
    elapsed < duration && requestAnimationFrame(scroll)
  }   
  requestAnimationFrame(scroll)
  //window.scrollTo(0, rect.top)
}



// WEBPACK FOOTER //
// ./lib/animation/slideto.js